/* OSKA globally shared recently viewed products: local to this browser and store. */
(function(root) {
  'use strict';
  if(root.OSKARecent) return;
  const KEY='oska-product-history-v1';
  const MAX=24;
  function sameStore(path) {
    try {
      const url=new URL(String(path||''),root.location.origin);
      if(url.origin!==root.location.origin||!/^\/(pages\/model-detail|collections\/panther|products\/)/.test(url.pathname)) return '';
      return url.pathname+url.search+url.hash;
    } catch(_error) {return '';}
  }
  function imageUrl(src) {
    try {
      const url=new URL(String(src||''),root.location.origin);
      if(!['http:','https:'].includes(url.protocol)) return '';
      if(url.origin!==root.location.origin&&url.hostname!=='cdn.shopify.com') return '';
      return url.href;
    } catch(_error) {return '';}
  }
  function limitText(value) {return String(value||'').trim().slice(0,220);}

  /* OSKA_CATEGORY_SCOPED_RECENT_V3: retain category with each visit;
     infer old history without wrongly showing rings on necklace pages. */
  function inferCategory(input,key,href) {
    const explicit=String(input.category||'').trim().toLowerCase();
    if(/^(women|men)-(rings|necklaces|bracelets|earrings)$/.test(explicit))return explicit;
    const type=explicit.match(/^(women|men)(?:['’]s)?[\s-]+(rings?|necklaces?|bracelets?|earrings?)\b/);
    if(type) {
      const singular={ring:'rings',necklace:'necklaces',bracelet:'bracelets',earring:'earrings'};
      return type[1]+'-'+(singular[type[2]]||type[2]);
    }
    const cat=String(key||'').match(/^catalog:((?:women|men)-(?:rings|necklaces|bracelets|earrings)):/);
    if(cat)return cat[1];
    const hit=String(key||'').match(/^signature:([^:]+):([^:]+)/);
    if(hit) {
      const group=hit[1],ref=hit[2];
      if(/^men-(chain|cuff|panther|chainmail)$/.test(group))return 'men-bracelets';
      if(/^men-(stud|hoop|earring)/.test(group))return 'men-earrings';
      if(/^women-ring(?:-|$)/.test(group))return 'women-rings';
      if(/^women-(stud|hoop|single)(?:-|$)/.test(group))return 'women-earrings';
      if(/^women-cuff(?:-|$)/.test(group))return 'women-bracelets';
      if(group==='women-chain'||group==='women-tennis') {
        if(/^OSKA-WN-/.test(ref))return 'women-necklaces';
        if(/^(OSKA-KZ-|OSKA-TN-)/.test(ref))return 'women-bracelets';
        return '';
      }
      if(/^women-(pendant|panther)(?:-|$)/.test(group))return /^OSKA-WN-/.test(ref)?'women-necklaces':'';
    }
    // Never infer a category from product imagery, titles, or untyped old records.
    return '';
  }
  /* OSKA_HOOP_HISTORY_REFRESH_V1 — replace old Hoop images in viewed history without deleting history. */
  const hoopImageRefresh={"OSKA-ME-HO-01":{"image":"https://cdn.shopify.com/s/files/1/1000/3474/0594/files/oska-men-hoop-new-01-20261009.png?v=1791575681","titleTR":"Minimal Parlak Halka","titleEN":"Polished Minimal Hoop"},"OSKA-ME-HO-02":{"image":"https://cdn.shopify.com/s/files/1/1000/3474/0594/files/oska-men-hoop-new-02-20261009.png?v=1791575689","titleTR":"Fırçalı Beyaz Halka","titleEN":"Brushed White Hoop"},"OSKA-ME-HO-03":{"image":"https://cdn.shopify.com/s/files/1/1000/3474/0594/files/oska-men-hoop-new-03-20261009.png?v=1791575697","titleTR":"Oniks Panel","titleEN":"Onyx Panel"},"OSKA-ME-HO-04":{"image":"https://cdn.shopify.com/s/files/1/1000/3474/0594/files/oska-men-hoop-new-04-20261009.png?v=1791575765","titleTR":"Oyma Barok","titleEN":"Carved Baroque Hoop"},"OSKA-ME-HO-05":{"image":"https://cdn.shopify.com/s/files/1/1000/3474/0594/files/oska-men-hoop-new-05-20261009.png?v=1791575774","titleTR":"Oyma İç Yüzey","titleEN":"Carved Inner Surface"},"OSKA-ME-HO-06":{"image":"https://cdn.shopify.com/s/files/1/1000/3474/0594/files/oska-men-hoop-new-06-20261009.png?v=1791575789","titleTR":"İki Tonlu Altın Çizgi","titleEN":"Two-Tone Gold Line"},"OSKA-ME-HO-07":{"image":"https://cdn.shopify.com/s/files/1/1000/3474/0594/files/oska-men-hoop-new-07-20261009.png?v=1791575798","titleTR":"Siyah Kare Oniks","titleEN":"Black Onyx Geometry"},"OSKA-ME-HO-08":{"image":"https://cdn.shopify.com/s/files/1/1000/3474/0594/files/oska-men-hoop-new-08-20261009.png?v=1791575806","titleTR":"Beyaz Taşlı Pavé Halka","titleEN":"White Pavé Hoop"},"OSKA-ME-HO-09":{"image":"https://cdn.shopify.com/s/files/1/1000/3474/0594/files/oska-men-hoop-new-09-20261009.png?v=1791575814","titleTR":"Örgü Dokulu Beyaz Halka","titleEN":"Woven White Hoop"},"OSKA-ME-HO-10":{"image":"https://cdn.shopify.com/s/files/1/1000/3474/0594/files/oska-men-hoop-new-10-20261009.png?v=1791575822","titleTR":"Siyah Örgü Altın Halka","titleEN":"Black Braid Gold Hoop"}};
  function updatedHoopRecord(input,key){
    const match=String(key||'').match(/^signature:men-hoop:(OSKA-ME-HO-\d{2})$/);
    return match&&hoopImageRefresh[match[1]]?Object.assign({},input,hoopImageRefresh[match[1]]):input;
  }
  function normalize(input) {
    if(!input||typeof input!=='object')return null;
    const key=limitText(input.key),fresh=updatedHoopRecord(input,key),href=sameStore(fresh.href),image=imageUrl(fresh.image);
    if(!key||!href||!image)return null;
    return {key,href,image,category:inferCategory(fresh,key,href),titleTR:limitText(fresh.titleTR),titleEN:limitText(fresh.titleEN),
      subtitleTR:limitText(fresh.subtitleTR),subtitleEN:limitText(fresh.subtitleEN),
      kind:limitText(fresh.kind||'model')};
  }
  function read() {
    try {
      const entries=JSON.parse(root.localStorage.getItem(KEY)||'[]');
      if(!Array.isArray(entries))return [];
      const seen=new Set(),valid=[];
      for(const raw of entries) {
        const item=normalize(raw);
        if(!item||seen.has(item.key))continue;
        seen.add(item.key);valid.push(item);
        if(valid.length===MAX)break;
      }
      return valid;
    } catch(_error) {return [];}
  }
  function save(list) {
    try {root.localStorage.setItem(KEY,JSON.stringify(list.slice(0,MAX)));}catch(_error){}
    root.document.dispatchEvent(new CustomEvent('oska:recent-updated'));
  }
  function record(raw) {
    const item=normalize(raw);
    if(!item)return false;
    const list=read();
    save([item,...list.filter(x=>x.key!==item.key)]);
    return true;
  }
  function importOlder(rows) {
    if(!Array.isArray(rows))return;
    const list=read(),seen=new Set(list.map(x=>x.key));
    let changed=false;
    for(const row of rows) {
      const item=normalize(row);
      if(!item||seen.has(item.key))continue;
      seen.add(item.key);list.push(item);changed=true;
      if(list.length===MAX)break;
    }
    if(changed)save(list);
  }
  root.OSKARecent={read,record,importOlder,key:KEY};
})(window);
